import { Link } from '@tanstack/react-router'
import type { ReactNode } from 'react'

import { Card, Page } from '@/components/layout'
import { useAuth } from '@/lib/auth-store'
import type { MessageKey } from '@/lib/i18n/messages/en'
import { useT } from '@/lib/i18n/translate'

/** Page-level twin of the nav's `visible` filter (E4): a typed URL gets a notice, not a page. */
export function RequireAdmin({ notice = 'users.adminOnly', children }: { notice?: MessageKey; children: ReactNode }) {
  const t = useT()
  const auth = useAuth('platform')
  if (auth.status !== 'authenticated') return null
  if (!auth.user.is_admin) {
    return (
      <Page width="sm" className="pt-10">
        <Card className="flex flex-col items-center gap-4 p-6">
          <p role="alert" className="text-center">
            {t(notice)}
          </p>
          <Link to="/" className="text-accent-ink font-medium hover:underline">
            {t('notFound.home')}
          </Link>
        </Card>
      </Page>
    )
  }
  return children
}
